/* unplugin-vue-components disabled */import { render } from "./commands-menu.vue?vue&type=template&id=067de3fe"
import script from "./commands-menu.vue?vue&type=script&lang=js"
export * from "./commands-menu.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/chat-input-v2/commands-menu/commands-menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "067de3fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('067de3fe', __exports__)) {
    api.reload('067de3fe', __exports__)
  }
  
  module.hot.accept("./commands-menu.vue?vue&type=template&id=067de3fe", () => {
    api.rerender('067de3fe', render)
  })

}


export default __exports__